export interface StoredAuthUser {
  id: string;
  name: string;
  email: string;
  role: string;
  team: string | null;
  active: boolean;
  status: string;
  last_login_at: string | null;
  created_at: string;
  updated_at: string;
}

export interface StoredAuthState {
  accessToken: string;
  refreshToken: string;
  user: StoredAuthUser;
}

export const AUTH_STORAGE_KEY = 'assetflow.auth';

export function readStoredAuth(): StoredAuthState | null {
  if (typeof window === 'undefined') {
    return null;
  }

  const raw = window.localStorage.getItem(AUTH_STORAGE_KEY);
  if (!raw) {
    return null;
  }

  try {
    return JSON.parse(raw) as StoredAuthState;
  } catch {
    return null;
  }
}

export function writeStoredAuth(state: StoredAuthState) {
  window.localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(state));
}

export function clearStoredAuth() {
  window.localStorage.removeItem(AUTH_STORAGE_KEY);
}